import Cookies from 'js-cookie'

const TokenKey = 'yunsmartcity_token'

export function getToken() {
    var token = Cookies.get(TokenKey)
    console.log("token-----",token)
    if(token){
      token = JSON.parse(token)
    }else{
      token = ''
      return token
    }
    return `${token.tokenType} ${token.token}`
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getCacheUserInfo() {
    const userInfoStr = window.localStorage.getItem('userInfo');
    const userInfo = (userInfoStr && JSON.parse(userInfoStr)) || {};
    return userInfo;
}

export function setStaticInfo(staticInfo){
  window.localStorage.setItem('staticInfo', JSON.stringify(staticInfo));
}

export function getStaticInfo(){
  const staticInfoStr = window.localStorage.getItem('staticInfo');
  const staticInfo = JSON.parse(staticInfoStr)//(staticInfoStr && JSON.parse(staticInfoStr)) || {};
  return staticInfo;
}
